"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AnsweredQuestionnaireExtractor {
    getAnsweredQuestionnaire(valuation, questionnaireType) {
        return valuation.getAnsweredQuestionnaires().find((questr) => {
            return questr.getId() === questionnaireType;
        });
    }
    getAnsweredQuestion(answeredQuestionnaires, question) {
        return answeredQuestionnaires.getAnsweredQuestions().find((quest) => {
            return quest.getId() === question;
        });
    }
    getAnswerOption(answeredQuestion) {
        return answeredQuestion.getChosenAnswerOptions().first();
    }
    /**
     * @inheritDoc
     */
    getAnswerToQuestion(valuation, question, questionnaireType) {
        const questionnaire = this.getAnsweredQuestionnaire(valuation, questionnaireType);
        if (!questionnaire) {
            return null;
        }
        const option = this.getAnsweredQuestion(questionnaire, question);
        if (!option) {
            return null;
        }
        const answer = this.getAnswerOption(option);
        if (!answer) {
            return null;
        }
        return answer.getValue();
    }
}
exports.default = AnsweredQuestionnaireExtractor;
